<template>
    <el-container>
        <el-header class="header">
            <div class="back" @click="goBack"><i class="el-icon-back"></i></div>
            <div class="title">自动组卷</div>
            <div class="placeholder">1</div>
        </el-header>
        <el-main class="content-box">
            <p class="title">组卷规则</p>
            <p class="tip">设定组卷规则，系统随机抽取试题自动组卷</p>
            <el-card class="box-card">
                <div class="form-box">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                        <el-form-item label="组卷题库" prop="bankList">
                            <el-button type="text" icon="el-icon-plus" @click="addBankRule">添加题库规则</el-button>
                            <div v-for="(item, index) in ruleForm.banks" :key="index" class="form-tiem-bank">
                                <el-form-item 
                                    label-width="66px"
                                    label="题库：" 
                                    class="option-info" 
                                    :prop="'banks['+index+'].bankStr'" 
                                    :key="`bankStr${index}`" 
                                    :rules="ruleFormBank.bankStr"
                                >
                                    <el-select 
                                        clearable 
                                        size="small" 
                                        v-model="item.bankStr" 
                                        placeholder="请选择"
                                    >
                                        <el-option-group
                                            v-for="group in bankOptions"
                                            :key="group.label"
                                            :label="group.label">
                                            <el-option
                                                v-for="info in group.options"
                                                :key="info.value"
                                                :label="info.label"
                                                :value="`${info.value},${info.label}`">
                                            </el-option>
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                                <el-form-item 
                                    label-width="66px"
                                    class="option-info" 
                                    :prop="'banks['+index+'].num'" 
                                    :key="`num${index}`" 
                                    :rules="ruleFormBank.num"
                                >
                                    <el-input 
                                        oninput="if(value){value=value.replace(/[^\d]/g, '')} if(value<=0){value=''}"
                                        size="small" v-model.number="item.num"></el-input>道题
                                </el-form-item ><el-form-item 
                                    label-width="66px"
                                    label="题型：" 
                                    class="option-info" 
                                    :prop="'banks['+index+'].quesTypeId'" 
                                    :key="`quesTypeId${index}`" 
                                    :rules="ruleFormBank.quesTypeId"
                                >
                                    <el-select 
                                        size="small"  
                                        v-model="item.quesTypeId" 
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in quesTypeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item 
                                    label-width="68px"
                                    label="难易度：" 
                                    class="option-info" 
                                    :prop="'banks['+index+'].difficultyStr'" 
                                    :key="`difficultyStr${index}`" 
                                    :rules="ruleFormBank.difficultyStr"
                                >
                                    <el-select 
                                        size="small" 
                                        v-model="item.difficultyStr" 
                                        placeholder="请选择"
                                    >
                                        <el-option
                                        v-for="info in difficultyList"
                                        :key="info.value"
                                        :label="info.label"
                                        :value="`${info.value},${info.label}`">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-button @click="delBankRule(index)" type="text" icon="el-icon-remove-outline" v-if="index > 0"></el-button>
                            </div>
                        </el-form-item>

                        <el-form-item label="试卷名称" prop="examName">
                            <el-input v-model="ruleForm.examName" placeholder="例：试卷1"></el-input>
                            <p class="tip">1-64个字符，可以使用汉字、字母、数字、下划线、中线、括号</p>
                        </el-form-item>
                        <el-form-item label="试卷描述" prop="depict">
                            <el-input v-model="ruleForm.depict"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="成卷套数" prop="examNum">
                            <el-input
                                oninput="if(value){value=value.replace(/[^\d]/g, '')} if(value<=0){value=''}"
                                v-model.number="ruleForm.examNum" placeholder="例：2"></el-input>
                        </el-form-item>

                        <el-form-item label="试卷相似度检测" prop="isDetection">
                            <el-switch
                                v-model="ruleForm.isDetection"
                                :active-value="1"
                                :inactive-value	="0"
                            ></el-switch>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-card>
        </el-main>
    </el-container>
</template>

<script>
import { mapState } from "vuex"
export default {
    name: 'TestQuestionBank',
    data() {
        let checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入试卷名称'));
            }
            if (!/^[a-zA-Z0-9_\(\)\（\）\-\u4e00-\u9fa5]+$/.test(value)) {
                callback(new Error('请使用汉字、字母、数字、下划线、中线、括号'));
            } else {
                if (value.toString().length > 64 || value.toString().length < 1) {
                    callback(new Error('长度在 1 到 64 个字符'));
                } else {
                    callback();
                }
            }
        };
        return{
            difficultyList: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 1,
                    label: '易'
                },
                {
                    value: 2,
                    label: '较易'
                },
                {
                    value: 3,
                    label: '中'
                },
                {
                    value: 4,
                    label: '较难'
                },
                {
                    value: 5,
                    label: '难'
                }
            ], 
            ruleFormBank:{
                bankStr:[
                    { required: true, message: '请选择题库', trigger: 'change' },
                ],
                examNum:[
                    { type: 'number', required: true, message: '请输入试题数量',trigger: 'blur',},
                ],
                difficultyStr:[
                    { required: false},
                ],
                quesTypeId:[
                    { required: false},
                ],
            },
            ruleForm: {
                examName: '',
                examNum: '',
                isDetection: 1,
                depict: '',
                banks:[{
                    bankStr: '',
                    difficultyStr: '1,易',
                    bankId: '',
                    bankName: '',
                    difficultyName: '',
                    num: 1,
                    difficulty: '',
                    quesTypeId: ''
                }],
            },
            rules: {
                examName: [
                    { required: true, validator: checkName, trigger: 'blur' },
                ],
                examNum:[
                    { type: 'number', required: true, message: '请输入试题数量',trigger: 'blur',},
                ],
                isDetection: [
                    { required: false },
                ],
                depict:[
                    { required: false },
                ],
            },
            bankOptions: [
                {
                    label: '自建题库',
                    options: []
                },
                {
                    label: '系统题库',
                    options: []
                }
            ],
        }
    },
    computed: {
		...mapState(['examQuesTypeArr']),
        quesTypeList() {
            let data = [{
                value: '',
                label: '不限'
            }]
            data = [...data, ...this.examQuesTypeArr]
            return data
        }
    },
    created(){
        this.getBankOptions()
    },
    methods: {
        delBankRule(i) {
            this.ruleForm.banks.splice(1, i)
        },
        addBankRule() {
            this.ruleForm.banks.push({
                bankStr: '',
                difficultyStr: '1,易',
                bankId: '',
                bankName: '',
                difficultyName: '',
                num: 1,
                difficulty: '',
                quesTypeId: ''
            })
        },
        getBankOptions() {
            this.getBankApi(0)
            this.getBankApi(1)
        },
        getBankApi(isSystem) {
            let that = this
            let data = this.$qs.stringify({
                'isSystem': isSystem, // 0自建题库 1系统题库
                'pageIndex': 1,
                'pageSize': 10000,
                'bankType': 0,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankList}?${data}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){
                        if (isSystem == 0) {
                            res.resultBody.datas.forEach((info) => {
                                that.bankOptions[0].options.push({
                                    label: info.name,
                                    value: info.id
                                })
                            })
                        } else {
                            res.resultBody.datas.forEach((info) => {
                                that.bankOptions[1].options.push({
                                    label: info.name,
                                    value: info.id
                                })
                            })
                        }
                    } else {
                        that.bankOptions = [{
                            label: '自建题库',
                            options: []
                        },
                        {
                            label: '系统题库',
                            options: []
                        }]
                    }
                },
            };
            this.$util.request(params);
        },
        submitForm(formName) {
            console.log(this.ruleForm)
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let that = this
                this.ruleForm.banks.forEach(info =>{
                    let str = info.bankStr
                    let str2 = info.difficultyStr
                    info.bankId = str.split(',')[0]
                    info.bankName = str.split(',')[1]
                    info.difficulty = parseInt(str2.split(',')[0])
                    info.difficultyName = str2.split(',')[1]
                })
                let params = {
                    that: this,
                    url: `${this.$config.service.examAddQuesToExam}`,
                    method: "POST",
                    data: this.ruleForm,
                    cb(res) {
                        console.log(res)
                        if (res.code == '0'){
                            that.$message({
                                message: res.message,
                                type: 'success'
                            });
                            that.goBack()
                        } else {
                            that.$message.error(res.message);
                        }
                    },
                };
                this.$util.request(params);
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        goBack() {
            this.$router.go(-1)
        },
    }
}
</script>

<style lang="scss" scoped>
.header{
    display: flex;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    justify-content: space-between;
    align-items: center;
    .back{
        [class^="el-icon-"]{
            color:#6d6d6d;
        }
        font-size: 24px;
        cursor: pointer;
        padding: 10px;
    }
    .title{
        font-size: 14px;
        color: #484848;
    }
    .placeholder{
        opacity: 0;
    }
}
.content-box{
    height: calc(100vh - 60px);
    .box-card{
        height: 100%;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
        background-color: #FFF;
        color: #303133;
        padding: 20px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        /deep/.el-card__body{
            width: 100%;
        }
        .form-box{     
            width: 869px;
            margin: 40px auto 0 auto;
            .form-tiem-bank+.form-tiem-bank{
                margin-top: 20px;
            }
            .form-tiem-bank{
                display: flex;
                .option-info{
                    display: flex;
                    /deep/.el-form-item__content{
                        margin-left: 0 !important;
                    }
                    /deep/.el-input{
                        width: 60px;
                        margin-right: 10px;
                    }
                    .el-select{
                        /deep/.el-input{
                            width: 120px;
                        }
                    }
                }
                .option-info+.option-info{
                    margin-left: 20px;
                }
            }
            .tip{
                font-size: 12px;
            }
        }
    }
    .title{
        font-size: 16px;
        font-weight: bold;
    }
    .tip{
        color: rgba(209, 207, 207, 1);
        font-size: 13px;
        line-height: 30px;
    }
}
</style>